export class SnapshotRecipeRuleError {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "order",
            "baseName": "order",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotRecipeRuleError.attributeTypeMap;
    }
    constructor() {
    }
}
